/* tslint:disable */
/* eslint-disable */
/**
 * Store
 * 店舗向けAPI
 *
 * The version of the OpenAPI document: 1.0
 * Contact: kiuchi@wcdi.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { GetRankingProducts200ResponseAllOfData } from './GetRankingProducts200ResponseAllOfData';
import {
    GetRankingProducts200ResponseAllOfDataFromJSON,
    GetRankingProducts200ResponseAllOfDataFromJSONTyped,
    GetRankingProducts200ResponseAllOfDataToJSON,
} from './GetRankingProducts200ResponseAllOfData';

/**
 * 
 * @export
 * @interface GetRankingProducts200ResponseAllOf
 */
export interface GetRankingProducts200ResponseAllOf {
    /**
     * 
     * @type {GetRankingProducts200ResponseAllOfData}
     * @memberof GetRankingProducts200ResponseAllOf
     */
    data: GetRankingProducts200ResponseAllOfData;
}

/**
 * Check if a given object implements the GetRankingProducts200ResponseAllOf interface.
 */
export function instanceOfGetRankingProducts200ResponseAllOf(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "data" in value;

    return isInstance;
}

export function GetRankingProducts200ResponseAllOfFromJSON(json: any): GetRankingProducts200ResponseAllOf {
    return GetRankingProducts200ResponseAllOfFromJSONTyped(json, false);
}

export function GetRankingProducts200ResponseAllOfFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetRankingProducts200ResponseAllOf {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': GetRankingProducts200ResponseAllOfDataFromJSON(json['data']),
    };
}

export function GetRankingProducts200ResponseAllOfToJSON(value?: GetRankingProducts200ResponseAllOf | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': GetRankingProducts200ResponseAllOfDataToJSON(value.data),
    };
}

